














import { State, Getter, Action } from 'vuex-class';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { SortOrder } from '@/enums/SortOrder';
import { Debounce } from '@/functions/debounce';
import { Searchable } from '@/mixins/searchable';

@Component({
  components: {
    PagePresetDashboard: () => import('@/layouts/presets/dashboard.vue'),
    TableBase: () => import('@/components/table/base.vue'),
    IndexSearch: () => import('@/components/parts/IndexSearch.vue'),
  },
})
export default class PageDieselTaxes extends Searchable<Option> {
  @Getter('workspace/selected') workspace!: Workspace;

  @Getter('option/all') options!: Option[];

  @Action('option/index') indexOptions!: ({ query, workspaceId }: { query?: IndexQuery<Option>; workspaceId: number }) => Promise<{ total: number; data: Option[] }>;

  i18n: string = 'views.options.index';

  searchItemsProperty = 'options';

  sorting = { key: 'id', order: SortOrder.ASC };

  tableLayout = {
    settings: {
      locale_path: `${this.i18n}.table`,
      max_height: 'calc(100% - 136px)',
      clickable: true,
    },
    structure: [
      {
        key: 'id',
        value: (model: Reseller) => `#${model.id}`,
        width: 75,
      },
      {
        key: 'key',
      },
      {
        key: 'name',
      },
      {
        key: 'type',
        value: (model: Option) => this.$t(`options.option_types.${model.type}`),
      },
      {
        key: 'filterable',
        value: (model: Option) => `<input type="checkbox" disabled${model.filterable ? ' checked' : ''}></input>`,
      },
    ],
  };

  get defaultSearchQuery() {
    return { or: { name: [`like:*${this.searchText}*`, `match:${this.searchText}`], key: [`like:*${this.searchText}*`, `match:${this.searchText}`] } };
  }

  @Debounce(500)
  handleSearch(searchText: string) {
    this.searchText = searchText;
    this.indexOptions({ query: { q: this.searchQuery, per_page: 20, s: this.sortQuery }, workspaceId: this.workspace.id });
  }

  handleSort(item: any) {
    this.sorting = item;
    this.indexOptions({ query: { q: this.searchQuery, per_page: 20, s: this.sortQuery }, workspaceId: this.workspace.id });
  }

  loadMore() {
    this.indexOptions({ query: { q: this.searchQuery, after: this.lastAfter, s: this.sortQuery }, workspaceId: this.workspace.id });
  }
}
